import api from './api';

export const getAnnouncements   = (params) => api.get('/api/announcements', { params });
export const createAnnouncement = (data)   => api.post('/api/announcements', data);
export const deleteAnnouncement = (id)     => api.delete(`/api/announcements/${id}`);
